module.exports = __webpack_public_path__ + "static/media/dailey_method.6e53f3d7.svg";